import { render } from "./UserLayout.vue?vue&type=template&id=e5473242&ts=true"
import script from "./UserLayout.vue?vue&type=script&lang=ts"
export * from "./UserLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__